export default __webpack_public_path__ + "static/media/landscape14.deb4879b.jpg";